import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SEARCH } from 'src/app/config';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css'],
    
})
export class SearchComponent implements OnInit {
  data:any;
  products:any;
  url:any;
  wish:any;
  alert:boolean;
  div:boolean;
  loader:boolean;
  page:boolean;
  pageNo = 1;
  current_page=1;
  message:any="Nothing To Show";
  drop:any;
  searchType:any;
  priceWeight:any;
  pages:any;
  profileData:any;
  // @ViewChild('addclosebutton') addclosebutton;
  // @ViewChild('deleteclosebutton') deleteclosebutton;
    constructor(private api:ApiService,private route:ActivatedRoute,private router:Router) { 
      this.drop=this.api.drop;
      // this.route.queryParams.subscribe(query => {
      //     this.searchType = query.type
      //     this.data=query.name;
      //     this.searchApi();
      // })
      this.profileData = JSON.parse(localStorage.getItem('profileInfo') || "null")
      this.route.params.subscribe(params => {
        this.data=params.value;
        this.searchType = params.type
        this.route.queryParamMap.subscribe(params =>{
          let a =  params.get('page');
          this.current_page = Number(a);
          this.pageNo = this.current_page;
          // this.getProduct(this.subid,this.current_page);
          this.searchApi(this.current_page);
        });
        
      });
      
    }
    ngOnInit() {
      this.loader=true;
      this.page=false;
      this.api.getlogin.subscribe(data => {
        console.log(+data);
        this.drop=data;
        console.log(this.drop);    
       });
  
    }

  searchApi(page:any)
  {
    this.loader=true;
    this.page=false;
    let obj = {}
    console.log("searchType", this.searchType)
    if(this.searchType == 'name'){
      obj['name'] = this.data;
      obj['user_type'] = this.profileData?.user_type;
    }else{
      obj['name'] = this.data,
      obj['search_type'] = 'code'
    }
    obj['page'] = page
    this.api.Post(SEARCH,obj).then(data=>{
      this.page=true;
        this.loader=false;
      this.alert=false;
      this.div=true;
      console.log(data);
      this.products = data['data'];
      this.priceWeight = this.api.calculateFilter(this.products,data['price'],this.api.igst);
      this.pages = Math.ceil(data['pagination']/32)
      console.log(this.products);
      this.url = data['url'] + '/';
    }).catch(d=>{
      this.page=true;
        this.loader=false;
      this.alert=true;
      this.div=false;
      console.log(d); 
    })
  }

  pagechanged(){
    this.router.navigate(['/search', this.data, this.searchType], { queryParams: { page: this.pageNo}});
  }

  go(value) {
    this.api.godetail(value);
  }
  checkCart(pid)
  {
      let check=this.api.checkCart(pid);
     // console.log(check);
      return check;
  }
  qtyUpdate(pid,value)
  {
      this.api.qtyUpdate(pid,value);
  }
  quantity(pid)
  {
      let cart=this.api.getCart();
      if(cart)
    {
            let result=cart.find(x => x.product_id == pid);
            // console.log(result);
            if(result)
            { 
                  let cartId=result.cart_id;
                  let c=Number(result.count);
                  return c;
              } 
              else{
                return(0);
              }
      }
  }
  wishlist(pid) {
    // console.log("in wishlist");
     //console.log(pid);
     if(this.drop==0)
       {
         this.api.setGoto();
         this.api.onSuccess('Please Login First to Continue','Login');
        //document.getElementById("openModalButton").click();
       }
       else if(this.drop==1)
      {
        this.api.checkWishlist(pid);
      }
   }
   deleteWishlist(pid)
   {
       this.api.deleteWishlist(pid);
   }
   checkHeart(pid)
  {
  
    //console.log("checkheart");
    this.wish = this.api.getWishlist();
    if (this.wish) {
            let result = this.wish.find(x => x.product_id === pid);
        //  console.log("result="+result);
            if (result)
            { 
             // console.log("present");
              return true;
            
            }
            else
            {
              //console.log("not present");
              return false;
              
            } 
      }
      else{
        //console.log("not present");
        return false;
      }
  }
  
    
  
  }
